import { forwardRef } from "react";

const TestimonialDocument = forwardRef(({ testimonial }, ref) => {
  const t = testimonial;
  const dateStr = new Date(t.created_at).toLocaleDateString("en-IN", {
    day: "numeric", month: "long", year: "numeric"
  });

  return (
    <div ref={ref} style={{
      width: "794px", height: "1123px", background: "#fff", position: "relative",
      fontFamily: "'Georgia', 'Times New Roman', serif", overflow: "hidden", color: "#1a1a1a"
    }}>
      {/* Outer gold border */}
      <div style={{
        position: "absolute", inset: "16px", border: "3px solid #b8860b",
        borderRadius: "4px", pointerEvents: "none"
      }} />
      {/* Inner subtle border */}
      <div style={{
        position: "absolute", inset: "22px", border: "1px solid #d4af37",
        borderRadius: "2px", pointerEvents: "none"
      }} />

      {/* Corner ornaments */}
      {["top-left", "top-right", "bottom-left", "bottom-right"].map(pos => {
        const isTop = pos.includes("top");
        const isLeft = pos.includes("left");
        return (
          <div key={pos} style={{
            position: "absolute",
            top: isTop ? "28px" : "auto",
            bottom: !isTop ? "28px" : "auto",
            left: isLeft ? "28px" : "auto",
            right: !isLeft ? "28px" : "auto",
            width: "50px", height: "50px",
            borderTop: isTop ? "2px solid #b8860b" : "none",
            borderBottom: !isTop ? "2px solid #b8860b" : "none",
            borderLeft: isLeft ? "2px solid #b8860b" : "none",
            borderRight: !isLeft ? "2px solid #b8860b" : "none",
          }} />
        );
      })}

      {/* Watermark */}
      <div style={{
        position: "absolute", top: "50%", left: "50%",
        transform: "translate(-50%, -50%) rotate(-30deg)",
        fontSize: "120px", fontWeight: "bold", color: "rgba(212, 175, 55, 0.04)",
        letterSpacing: "12px", whiteSpace: "nowrap", pointerEvents: "none",
        fontFamily: "'Georgia', serif"
      }}>BCH</div>

      {/* Content */}
      <div style={{ padding: "40px 60px", position: "relative", zIndex: 1, height: "100%", display: "flex", flexDirection: "column" }}>

        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "4px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "14px", marginBottom: "2px" }}>
            <img src="/bch-logo.png" alt="BCH" style={{
              width: "260px", height: "auto", objectFit: "contain"
            }} crossOrigin="anonymous" />
          </div>
          <div style={{ width: "200px", height: "1px", background: "linear-gradient(90deg, transparent, #b8860b, transparent)", margin: "8px auto" }} />
        </div>

        {/* Title */}
        <div style={{ textAlign: "center", margin: "2px 0 10px" }}>
          <h2 style={{ fontSize: "28px", fontWeight: "bold", color: "#b8860b", letterSpacing: "6px", margin: 0, textTransform: "uppercase" }}>
            TESTIMONIAL
          </h2>
          <p style={{ fontSize: "11px", color: "#999", marginTop: "3px", letterSpacing: "2px" }}>CERTIFICATE OF APPRECIATION</p>
        </div>

        {/* Presented To */}
        <div style={{ textAlign: "center", margin: "4px 0 10px" }}>
          <p style={{ fontSize: "13px", color: "#666", marginBottom: "4px" }}>This testimonial is presented to</p>
          <h3 style={{
            fontSize: "32px", fontWeight: "bold", color: "#1a5c3a", margin: "0 0 3px",
            borderBottom: "2px solid #d4af37", display: "inline-block", paddingBottom: "3px", lineHeight: "1.2"
          }}>
            {t.to_user_name}
          </h3>
          <p style={{ fontSize: "15px", color: "#444", margin: "4px 0 1px", fontWeight: "600" }}>{t.to_business_name}</p>
          <p style={{ fontSize: "12px", color: "#888" }}>{t.to_business_category} &bull; {t.to_chapter_name}</p>
        </div>

        {/* Service Taken */}
        <div style={{
          background: "linear-gradient(135deg, #f8f6f0, #faf8f2)", border: "1px solid #e8e0c8",
          borderRadius: "6px", padding: "10px 20px", margin: "6px 0", textAlign: "center"
        }}>
          <p style={{ fontSize: "10px", color: "#999", textTransform: "uppercase", letterSpacing: "3px", marginBottom: "3px" }}>Service Availed</p>
          <p style={{ fontSize: "17px", color: "#1a5c3a", fontWeight: "bold", margin: 0 }}>{t.service_taken}</p>
        </div>

        {/* Testimonial Text */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", margin: "8px 0" }}>
          <div style={{
            position: "relative", padding: "20px 30px",
            background: "#fdfcfa", borderLeft: "3px solid #d4af37", borderRadius: "0 6px 6px 0"
          }}>
            <span style={{ position: "absolute", top: "-8px", left: "10px", fontSize: "60px", color: "#d4af37", lineHeight: 1, fontFamily: "Georgia, serif" }}>&ldquo;</span>
            <p style={{
              fontSize: "14px", lineHeight: "1.8", color: "#333", margin: "10px 0 0",
              fontStyle: "italic", textAlign: "justify"
            }}>
              {t.testimonial_text}
            </p>
            <span style={{ position: "absolute", bottom: "-30px", right: "10px", fontSize: "60px", color: "#d4af37", lineHeight: 1, fontFamily: "Georgia, serif" }}>&rdquo;</span>
          </div>
        </div>

        {/* Given By */}
        <div style={{ marginTop: "auto" }}>
          <div style={{ width: "100%", height: "1px", background: "linear-gradient(90deg, transparent, #d4af37, transparent)", margin: "16px 0" }} />
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
            <div>
              <p style={{ fontSize: "10px", color: "#999", textTransform: "uppercase", letterSpacing: "2px", marginBottom: "4px" }}>Given By</p>
              <p style={{ fontSize: "18px", fontWeight: "bold", color: "#1a1a1a", margin: "0 0 2px" }}>{t.from_user_name}</p>
              <p style={{ fontSize: "12px", color: "#555", margin: 0 }}>{t.from_business_name}</p>
              <p style={{ fontSize: "11px", color: "#888", margin: "2px 0 0" }}>{t.from_business_category} &bull; {t.from_chapter_name}</p>
            </div>
            <div style={{ textAlign: "right" }}>
              <p style={{ fontSize: "10px", color: "#999", textTransform: "uppercase", letterSpacing: "2px", marginBottom: "4px" }}>Date Issued</p>
              <p style={{ fontSize: "14px", color: "#1a1a1a", fontWeight: "600", margin: 0 }}>{dateStr}</p>
            </div>
          </div>

          {/* Footer */}
          <div style={{
            marginTop: "16px", paddingTop: "10px",
            borderTop: "1px solid #e8e0c8", textAlign: "center"
          }}>
            <p style={{ fontSize: "9px", color: "#bbb", letterSpacing: "2px", margin: 0 }}>
              BCH NETWORKING &bull; VERIFIED MEMBER TESTIMONIAL &bull; REF: {t.id?.slice(0, 8).toUpperCase()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
});

TestimonialDocument.displayName = "TestimonialDocument";
export default TestimonialDocument;
